<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ "Interim Data Analysis" }}</h2>
    </div>
  </div>

  <div>
    <div class="wrapper wrapper-content">
      <div class="ibox-body">
        <div class="ibox-title style_2 d-flex justify-content-between">
          <h5 class="mt-1">{{ "Snapshots" }}</h5>
         <div
             type="button"
             class="btn btn-sm btn-outline-primary py-0 d-inline-flex align-items-center gap-1"
             style="font-size: 12px;"
            @click="opensdtmModal()">
           <span class="pr-1" style="font-size: 14px; line-height: 1;">+</span>
            New Snapshot
        </div>
        </div>
        <div class="ibox-content">
          <div class="table-responsive">
            <table class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                  <th  
                    class="sort_block"
                    @click="SortSelected('InterimVersion', 1)"
                    id="1">
                    <div class="d-flex flex-row justify-content-between">
                        {{ "Interim Version" }}
                        <span>
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                        </span>
                    </div>
                  </th>
                  <th  
                    class="sort_block"
                    @click="SortSelected('DatasetVersion', 2)"
                    id="2"> 
                       <div class="d-flex flex-row justify-content-between">
                          Dataset Version
                          <span>
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                      </div>
                  </th>
                  <th
                    class="sort_block"
                    @click="SortSelected('CreatedAt', 3)"
                    id="3"
                  > 
                     <div class="d-flex flex-row justify-content-between">
                           Created At
                          <span>
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                      </div>
                  </th>
                  <th
                    class="sort_block"
                    @click="SortSelected('CreatedBy', 4)"
                    id="4"
                  > 
                     <div class="d-flex flex-row justify-content-between">
                        Created By 
                        <span>
                          <i class="fa fa-long-arrow-up"></i>
                          <i class="fa fa-long-arrow-down"></i>
                        </span>
                    </div>
                  </th>
                  <th>
                    <div class="d-flex flex-row justify-content-between">
                      {{ "Description" }}
                    </div>
                  </th>
                  <th>Status</th>

                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(audit, index) in auditList"
                  :key="audit.id"
                  :value="audit.id"
                >
                  <td>{{ audit.InterimVersion }}</td>
                  <td> {{ audit.DatasetVersion }}</td>
                  <td>{{ filter(audit.CreatedAt) }}</td>
                  <td> {{ audit.CreatedByEmail }}</td>
                  <td>{{ audit.Comment }}</td>
                  <td>{{ audit.Islocked ? "Locked" : "Unlocked" }}</td>
                  <td
                    class="text-center"
                    v-on:clickout="showSidePopup[index] = false"
                    v-if="!audit.Islocked"
                  >
                    <div
                      v-if="audit.InterimVersion !='Base'"
                      class="position-relative cursor-pointer"
                      @click.prevent="showSidePopup[index] = !showSidePopup[index]"
                    >
                      <i class="fa fa-ellipsis-v"></i>
                    </div>

                    <div class="plan-side-popup" v-if="showSidePopup[index]">
                      <div @click.prevent="toggleInterimDataLock(audit)">
                        {{ audit.Islocked ? "Unlock" : "Lock" }}
                      </div>
                    </div>
                  </td>
                  <td v-else></td>
                </tr>
              </tbody>
            </table>
            <!------ pagination -------->
            <div class="row mx-0">
              <div class="col-lg-12 mx-0 px-0">
                <div
                  class="dataTables_paginate paging_simple_numbers pagination float-right"
                >
                  <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                    <v-pagination
                      v-model="currentPage"
                      :pages="totalItems"
                      :range-size="1"
                      active-color="#618bd7"
                      @update:modelValue="loadPage"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!---Pagination ends-->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Audit trail details modal starts -->

  <!-- sdtm create popup -->
  <customModal
    v-if="openSDTmModal == true"
    :containersm="true"
    @closeModal="sdtmclosemodal()"
  >
    <template #title>
      Snapshot Details
    </template>
    <template #body>
      <div class="row justify-content-center">
        <div class="col-lg-12 my-0">
          <label class="fs-7">
            Interim Version
            <sup><i class="fa fa-asterisk required"></i></sup>
          </label>
          <input 
              type="text"  
              class="form-control py-1"
              v-model="intrimData.sdtmVersion"
              @change="clearError('sdtmVersion')">
          <!-- <select
            class="form-control py-1"
            v-model="intrimData.sdtmVersion"
            @change="clearError('sdtmVersion')"
          >
            <option disabled selected value="">Select</option>
            <option
              v-for="version in interimVersions"
              :key="version"
              :value="version"
            >
              {{ version }}
            </option>
          </select> -->
          <span v-if="errors.sdtmVersion" class="text-danger">{{
            errors.sdtmVersion
          }}</span>
          <span v-if="errors.sdtmVersionDuplicate" class="text-danger">{{
            errors.sdtmVersionDuplicate
          }}</span>
        </div>

        <div class="col-lg-12 my-0">
          <label class="fs-7">
            Comment
          </label>
          <input
            type="text"
            class="form-control py-1"
            v-model="intrimData.SdtmComments"
          />
        </div>

        <div class="col-lg-12 mt-4 d-flex justify-content-center">
          <button
            type="button"
            class="save_btn py-1 px-4"
            :disabled="showLoading"
            @click="CreateInterimVersion()"
            :class="{ 'disabled-btn-cls': showLoading }"
          >
            <div
              class="toc-loader position-absolute"
              :class="{ 'opacity-0': !showLoading, 'opacity-1': showLoading }"
            >
              <img
                src="../../assets/img/loading.gif"
                width="15"
                class="loading-btn-img"
                alt="Loading..."
              />
            </div>
            <div
              :class="{ 'opacity-1': !showLoading, 'opacity-0': showLoading }"
            >
              {{ $t("navigations.create") }}
            </div>
          </button>
        </div>

        <div class="errorClass" v-if="validations[0]">
          {{ $t("navigations.please fill all fields") }}
        </div>
      </div>
    </template>
  </customModal>
</template>
<script src="./interimDataset.js"></script>

<style>
@import "../../assets/savepages.css";
.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 56px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(150px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.plan-side-popup > div {
  cursor: pointer;
  padding: 0.5rem;
}

.plan-side-popup > div:hover {
  background-color: #e4eaf9;
}

.plan-side-popup > div:hover {
  background-color: #e4eaf9;
}

.icon-hover {
  font-size: 16px;
  transition: transform 0.2s ease;
}

.icon-hover:hover {
  transform: scale(1.1);
}
.opacity-0 {
  opacity: 0;
}

.opacity-1 {
  opacity: 1;
}

.disabled-btn-cls {
  opacity: 0.6;
  pointer-events: none;
}
</style>
